import { createFileRoute } from '@tanstack/react-router'

import { SettingsRoute } from '@/pages/account/route-entries/settings'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/_private/app/user/settings')({
  component: SettingsRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('Settings'),
        },
      ],
    }
  },
})
